import React from "react";
import "./style.css";
import { Box, Typography } from "@mui/material";
const StepCard = (props) => {
  const { number, title, description } = props;
  return (
    <>
      <div class="card">
        <div class="bg">
          <Box>
            <Box
              sx={{
                paddingTop: "20px",
                paddingBottom: "20px",
                textAlign: "left",
                paddingX: "15px",
              }}
            >
              {" "}
              <Typography
                variant="p"
                sx={{ fontSize: "30px", fontWeight: "700", color: "#000" }}
              >
                {title}
              </Typography>
            </Box>
            <Box
              sx={{
                paddingX: "15px",
                textAlign: "left",
              }}
            >
              {" "}
              <Typography
                variant="p"
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#000",
                }}
              >
                {description}
              </Typography>
            </Box>
          </Box>
        </div>
        <div class="blob"></div>
      </div>
    </>
  );
};

export default StepCard;
